var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradient3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "2560px",
    height: "2560px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 2560 2560",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-0.3125 -2.07854 1.88698 -0.169082 -1301 7838)",
    cx: 2432,
    cy: 2380.8,
    r: 537.6,
    fx: 2432,
    fy: 2380.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#D09BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 1,
    stopColor: "#F1D7FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.75625 1.82646 -1.87211 -1.7187 6141 -3766)",
    cx: 2176,
    cy: 76.7988,
    r: 640.001,
    fx: 2176,
    fy: 76.7988
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#FFF8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74902,
    stopOpacity: 1,
    stopColor: "#E5D1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#CCABDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.78241 1.72557 -1.77037 -1.74606 6579 -3096)",
    cx: 2201.6,
    cy: 255.998,
    r: 691.2,
    fx: 2201.6,
    fy: 255.998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#FFF8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521569,
    stopOpacity: 1,
    stopColor: "#F3DDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#E7C3FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.59097E-006 -1.61419 0.986227 0.0470411 387 5967)",
    cx: 2457.6,
    cy: 2099.2,
    r: 716.801,
    fx: 2457.6,
    fy: 2099.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#C499D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580392,
    stopOpacity: 1,
    stopColor: "#C8A2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#CCABDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id4",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.503471 1.81443 -2.0631 0.307638 1953 -3554)",
    cx: 2124.8,
    cy: 435.197,
    r: 460.8,
    fx: 2124.8,
    fy: 435.197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#FFEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580392,
    stopOpacity: 1,
    stopColor: "#FFEEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#FFEEEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.14286 -1.05033 1.0298 2.10122 -2337 -2150)",
    cx: 153.599,
    cy: 2099.2,
    r: 896.001,
    fx: 153.599,
    fy: 2099.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#E1BEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580392,
    stopOpacity: 1,
    stopColor: "#F0D6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#FFEEEC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F1D7FF",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id0)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id1)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id2)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id3)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id4)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id5)",
    width: 2560,
    height: 2560
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient3);
export default __webpack_public_path__ + "static/media/gradient3.366a80f0391316dd173daec15bef9d2d.svg";
export { ForwardRef as ReactComponent };